/**
 * Created by sunilkarthicksivabalan on 29/06/20.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
